import React from 'react';
import { useState } from 'react';
import {
  Button,
  Text,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { AudioBookEpisode } from '../../../generated/client';

/**
 * The AudioBookEpisode component does the following:
 * -- displays an audiobook card with the title of an episode and "view episode" button
 * -- renders file of the given episode to be listened to in a Modal when a user views the episode
 *
 * @param props: An 'episode', which is an AudioBookEpisode
 */

interface Props {
  episode: AudioBookEpisode;
}

export function AudioBookEpisodes({ episode }: Props): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className='resultsWrap'>
      <Text fontSize='md'>{episode.title}</Text>
      <Button colorScheme='teal' onClick={openModal}>
        View Episode
      </Button>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{episode.title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <iframe title='Podcast' src={episode.link} style={{ width: '100%', height: '500px' }} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}
